import { CommonContext } from '@repo-level/core-front';
import { Button } from 'components/buttons';
import { TabBarContext } from 'contexts/tabBarSize';
import {
  localStorageIsStag,
  localStorageSpecialStag,
} from 'modules/userTrackingParams';
import type { FC } from 'react';
import { useCallback, useContext, useMemo } from 'react';
import { Trans, useTranslation } from 'react-i18next';
import { useNavigation } from 'react-navi';
import type { IScCookieProps } from './styled';
import { ScCookie, ScLink } from './styled';
export interface ICookieProps extends IScCookieProps {
  onClose: () => void;
}

export const Cookie: FC<ICookieProps> = ({ onClose }) => {
  const { t } = useTranslation('common');
  const { navigate } = useNavigation();
  const { currentIp } = useContext(CommonContext);

  const isAUCookies = useMemo(
    () =>
      currentIp?.countryCode === 'AU' &&
      !(localStorageIsStag.get() || localStorageSpecialStag.get()),
    [currentIp?.countryCode]
  );

  const handleCookiePolicyRedirect = useCallback(
    () => navigate('/cookie-policy'),
    [navigate]
  );

  const { tabBarHeight } = useContext(TabBarContext);

  const cookieText = useMemo(
    () =>
      isAUCookies ? (
        <Trans i18nKey="common:cookie.AUText">
          We use{' '}
          <ScLink onClick={handleCookiePolicyRedirect}>Cookie Policy</ScLink>.
          Also in proceeding I confirm that I am currently accessing this
          website from outside of Australia.
        </Trans>
      ) : (
        <Trans i18nKey="common:cookie.defaultText">
          We use cookies to improve your experience. By using our website you
          are accepting our
          <ScLink onClick={handleCookiePolicyRedirect}>Cookie Policy</ScLink>
        </Trans>
      ),
    [isAUCookies, handleCookiePolicyRedirect]
  );

  return (
    <ScCookie bottom={tabBarHeight}>
      <div className="text">{cookieText}</div>
      <Button _width={107} blue medium onClick={onClose}>
        {t('glossary:continue')}
      </Button>
    </ScCookie>
  );
};
